import { computed } from '@vue/composition-api';

export default function useSizeOptions(locale, t) {
  return computed(() => [
    {
      value: 'sticker_10x10',
      type: 'square',
      category: t('sticker'),
      sizePx: '344x344',
      realSize: locale.value === 'ru'
        ? '200x200mm'
        : '8x8in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '56px'
          : '73px',
        lineHeight: locale.value === 'ru'
          ? '56px'
          : '63px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Квадратный | 200x200мм'
        : 'Square | 8" x 8"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/sticker-ru10x10.jpg')
        : require('@/assets/img/qr/create/en/sticker-en10x10.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/stickers/kvadratnye'
        : 'https://www.vistaprint.com/signs-posters/window-decals',
    },
    {
      value: 'banner_10x20',
      type: 'vertical',
      category: t('sticker'),
      sizePx: '258x344',
      realSize: locale.value === 'ru'
        ? '420x297mm'
        : '11x8.5in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '38px'
          : '71px',
        lineHeight: locale.value === 'ru'
          ? '38px'
          : '71px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Вертикальный | 420x297мм (А3)'
        : 'Vertical | 11" x 8.5"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/banner-ru10x20.jpg')
        : require('@/assets/img/qr/create/en/banner-en10x20.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'http://demo.pixlpark.ru/signs/banners'
        : 'https://www.vistaprint.com/signs-posters/vinyl-banners',
    },
    {
      value: 'poster_20x10',
      type: 'horizontal',
      category: t('sticker'),
      sizePx: '344x258',
      realSize: locale.value === 'ru'
        ? '500x700mm'
        : '1x2ft',
      styles: {
        fontSize: locale.value === 'ru'
          ? '41px'
          : '69px',
        lineHeight: locale.value === 'ru'
          ? '41px'
          : '63px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'end',
      },
      label: locale.value === 'ru'
        ? 'Горизонтальный | 500x700мм'
        : "Horizontal | 1' x 2'",
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/poster-ru20x10.jpg')
        : require('@/assets/img/qr/create/en/poster-en20x10.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/canvases/posters'
        : 'https://www.vistaprint.com/signs-posters/posters',
    },
    {
      value: 'sticker_25x25',
      type: 'square',
      category: t('poster'),
      sizePx: '344x344',
      realSize: locale.value === 'ru'
        ? '400x400mm'
        : '12x12in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '56px'
          : '73px',
        lineHeight: locale.value === 'ru'
          ? '56px'
          : '63px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Квадратный | 400x400мм'
        : 'Square | 12" x 12"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/sticker-ru25x25.jpg')
        : require('@/assets/img/qr/create/en/sticker-en25x25.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/stickers/kvadratnye'
        : 'https://www.vistaprint.com/signs-posters/window-decals',
    },
    {
      value: 'banner_20x40',
      type: 'vertical',
      category: t('poster'),
      sizePx: '258x344',
      realSize: locale.value === 'ru'
        ? '594x420mm'
        : '24x18in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '38px'
          : '71px',
        lineHeight: locale.value === 'ru'
          ? '38px'
          : '71px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Вертикальный | 594x420мм (А2)'
        : 'Vertical | 24" x 18"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/banner-ru20x40.jpg')
        : require('@/assets/img/qr/create/en/banner-en20x40.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'http://demo.pixlpark.ru/signs/banners'
        : 'https://www.vistaprint.com/signs-posters/vinyl-banners',
    },
    {
      value: 'poster_40x20',
      type: 'horizontal',
      category: t('poster'),
      sizePx: '344x258',
      realSize: locale.value === 'ru'
        ? '700x1000mm'
        : '2.5x4ft',
      styles: {
        fontSize: locale.value === 'ru'
          ? '41px'
          : '69px',
        lineHeight: locale.value === 'ru'
          ? '41px'
          : '63px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'end',
      },
      label: locale.value === 'ru'
        ? 'Горизонтальный | 700x1000мм'
        : "Horizontal | 2.5' x 4'",
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/poster-ru40x20.jpg')
        : require('@/assets/img/qr/create/en/poster-en40x20.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/canvases/posters'
        : 'https://www.vistaprint.com/signs-posters/posters',
    },
    {
      value: 'sticker_50x50',
      type: 'square',
      category: t('banner'),
      sizePx: '344x344',
      realSize: locale.value === 'ru'
        ? '600x600mm'
        : '24x24in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '56px'
          : '73px',
        lineHeight: locale.value === 'ru'
          ? '56px'
          : '63px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Квадратный | 600x600мм'
        : 'Square | 24" x 24"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/sticker-ru50x50.jpg')
        : require('@/assets/img/qr/create/en/sticker-en50x50.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/stickers/kvadratnye'
        : 'https://www.vistaprint.com/signs-posters/window-decals',
    },
    {
      value: 'banner_40x80',
      type: 'vertical',
      category: t('banner'),
      sizePx: '258x344',
      realSize: locale.value === 'ru'
        ? '841x594mm'
        : '40x28in',
      styles: {
        fontSize: locale.value === 'ru'
          ? '38px'
          : '71px',
        lineHeight: locale.value === 'ru'
          ? '38px'
          : '71px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      label: locale.value === 'ru'
        ? 'Вертикальный | 841x594мм (А1)'
        : 'Vertical | 40" x 28"',
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/banner-ru40x80.jpg')
        : require('@/assets/img/qr/create/en/banner-en40x80.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'http://demo.pixlpark.ru/signs/banners'
        : 'https://www.vistaprint.com/signs-posters/vinyl-banners',
    },
    {
      value: 'poster_80x40',
      type: 'horizontal',
      category: t('banner'),
      sizePx: '344x258',
      realSize: locale.value === 'ru'
        ? '1000x2000mm'
        : '4x6ft',
      styles: {
        fontSize: locale.value === 'ru'
          ? '41px'
          : '69px',
        lineHeight: locale.value === 'ru'
          ? '41px'
          : '63px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'end',
      },
      label: locale.value === 'ru'
        ? 'Горизонтальный | 1000x2000мм'
        : "Horizontal | 4' x 6'",
      preview: locale.value === 'ru'
        ? require('@/assets/img/qr/create/ru/poster-ru80x40.jpg')
        : require('@/assets/img/qr/create/en/poster-en80x40.jpg'),
      printServiceLink: locale.value === 'ru'
        ? 'https://digital-printing.ru/canvases/posters'
        : 'https://www.vistaprint.com/signs-posters/posters',
    },
  ]);
}
